import { Params, ResolveFn } from '@angular/router'
import { Breadcrumb } from './breadcrumb'

/**
 *
 * Supporting type for a dynamic data resolver for a breadcrumb.
 *
 * Implement this type on a subclass, return the desired breadcrumb label and associate the subclass with a route data
 * resolver.
 *
 * See BreadcrumbsComponent for a full example.
 *
 */
export interface BreadcrumbResolver {
  resolve: ResolveFn<string | undefined>
}
export interface BreadcrumbObjectResolver {
  resolve: ResolveFn<Breadcrumb | undefined>
}

export function buildBreadcrumb(label: string, url: string, queryParams?: Params, parent?: Breadcrumb): Breadcrumb {
  return {
    label,
    link: { url, queryParams: queryParams || {} },
    customParent: parent,
  }
}

export const HOME_BREADCRUMB: Breadcrumb = buildBreadcrumb('Home', '/')

/**
 * Avoid passing `state.url` directly as the `url` parameter when this route has child routes —
 * the breadcrumb will reflect the child route's URL instead of the parent's.
 * Instead, truncate the URL at the parent route's path segment before passing it in.
 */
export function buildBreadcrumbWithHomeParent(label: string, url: string, queryParams?: Params): Breadcrumb {
  return buildBreadcrumb(label, url, queryParams, HOME_BREADCRUMB)
}
